export default{
    
    lista:{
        method:'get',
        url:'reintegracao/trabalhador/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'reintegracao/trabalhador/cadastro'
    },
    delete:{
        method:'delete',
        url:'reintegracao/trabalhador/deletar{/id}'
    },
    deleteremoneracaoempresa:{
        method:'delete',
        url:'desligamento/remoneracao/empresa/trabalhador/deletar{/id}'
    },
    deletevalorcalculo:{
        method:'delete',
        url:'desligamento/valor/calculo/trabalhador/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'reintegracao/trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'reintegracao/trabalhador/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    },
    update2298:{
        method:'put',
        url:'reintegracao/trabalhador/2298/update'
    },
    cadastra2298:{
        method:'post',
        url:'reintegracao/trabalhador/2298/cadastro'
    },
    delete2298:{
        method:'delete',
        url:'reintegracao/trabalhador/2298/deletar{/id}'
    },
}